import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (back/forward buttons), use it
    if (savedPosition) {
      return savedPosition;
    }
    // If navigating to a route with hash (#section), scroll to that element
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      };
    }
    // For all other navigations, scroll to top
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import("../views/new_login.vue"),
      meta: { title: "ORO - Login" }
    },
    {
      path: '/new_login',
      name: 'New_Login',
      component: () => import("../views/LoginPage.vue"),
      meta: { title: "ORO - Login" }
    },
    {
      path: "/",
      name: "Home",
      component: () => import("../views/Home_page.vue"),
      meta: {
        title: "ORO - Home",
        auth: true,
      },
      children: [
        // Default child: redirect root to landing page so visiting the domain shows the landing
        {
          path: "",
          redirect: "/landing",
        },
        {
          path: "/landing", // ✅ No leading slash so it becomes "/landing"
          name: "Landing_Page",
          meta: { title: "ORO - Home" },
          component: () => import("../views/new_landing_page.vue"),
        },
        {
          path: "/new_landing", // ✅ No leading slash so it becomes "/landing"
          name: "Landing_Page",
          meta: { title: "ORO - Home" },
          component: () => import("../views/new_landing_page.vue"),
        },
        {
          path: "/Authenticator", //
          name: "Authenticator_Page",
          meta: { title: "ORO - Authenticator" },
          component: () => import("../views/Authenticator.vue"),
        },
        {
          path: "/Authenticator_your_product", //
          name: "Authenticator_your_product",
          meta: { title: "ORO - Authenticator" },
          component: () => import("../views/Authenticator_your_product.vue"),
        },
        {
          path: "/Authenticity_card", //
          name: "Authenticator_Page",
          meta: { title: "ORO - Authenticator" },
          component: () => import("../views/Authenticity_card.vue"),
        },
        {
          path: "/partner_of_oro", //
          name: "PartnerOfOro_Page",
          meta: { title: "ORO - Partner with ORO" },
          component: () => import("../views/partner_of_oro.vue"),
        },
        {
          path: "/my_oro_product", //
          name: "myOroProduct_Page",
          meta: { title: "ORO - My ORO" },
          component: () => import("../views/my_oro_product.vue"),
        },
        {
          path: "/favorites", //
          name: "favorites_Page",
          meta: { title: "ORO - Favourites" },
          component: () => import("../views/favorites.vue"),
        },
         {
          path: "/collections", //
          name: "collections_Page",
          meta: { title: "ORO - Collections" },
          component: () => import("../views/collections.vue"),
        },
        {
          path: "/collections_products/:id", //
          name: "collections_Products",
          meta: { title: "ORO - Collections" },
          component: () => import("../views/collections_products.vue"),
        },
        {
          path: "/Store_Locator", //
          name: "Store_Locator_Page",
          meta: { title: "ORO - Stores" },
          component: () => import("../views/Store_Locator.vue"),
        },
         {
          path: "/collection_to_store/:design_class/:collection_id", //
          name: "collection_to_store",
          meta: { title: "ORO - Stores" },
          component: () => import("../views/collections_to_store.vue"),
        },
           {
          path: "/collections/:collection_id", //
          name: "collection_to_store",
          meta: { title: "ORO - Stores" },
          component: () => import("../views/landing_collection_to_store.vue"),
        },
        {
          path: "/Collections/:storeId/:storeName", //
          name: "Collections_By_Store",
          meta: { title: "ORO - Collections" },
          component: () => import("../views/store_collections.vue"),
        },
         {
          path: "/store_to_collections_products/:id", //
          name: "store_to_collections_products",
          meta: { title: "ORO - Collections" },
          component: () => import("../views/store_to_collections_products.vue"),
        },
         {
          path: "/requested_product", //
          name: "requested_product",
          meta: { title: "ORO - Products" },
          component: () => import("../views/requested_product_page.vue"),
        },
         {
          path: "/requested_product_store", //
          name: "requested_product_store",
          meta: { title: "ORO - Products" },
          component: () => import("../views/requested_product_store.vue"),
        },
        {
          path: "/oro_for_you",
          name: "oro_for_you_Page",
          meta: { title: "ORO for you" },
          component: () => import("../views/oro_for.vue"),
        }
      ]
      
    },
  ],
});

// ✅ Navigation guards must be on the router instance
router.beforeEach((to, from, next) => {
  console.log('🧭 ROUTER: Navigating from', from.fullPath, 'to', to.fullPath);
  console.log('🧭 ROUTER: Current URL:', window.location.href);
  next();
});

router.afterEach((to) => {
  const defaultTitle = "ORO";
  document.title = to.meta.title || defaultTitle;
  console.log('🧭 ROUTER: Navigation completed to', to.fullPath);
});

export default router;
